/*** IMPORTS FROM imports-loader ***/
(function() {

"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
var iUA = navigator.userAgent;
exports.UA = {
    firefox: /Firefox/i.test(iUA),
    ie: 'ActiveXObject' in window && /(msie |Trident\/.*rv:)(\d*)/i.test(iUA) ? RegExp.$2 : false
};
exports.localStorage = {
    cache: {},
    removeItem: function (name) {
        var self = this;
        if (name in self.cache) {
            delete self.cache[name];
        }
        try {
            var ls = window.localStorage;
            ls.rmoveItem(name);
        }
        catch (er) {
        }
    },
    setItem: function (name, data) {
        var self = this;
        self.cache[name] = data;
        try {
            var ls = window.localStorage;
            if (ls) {
                ls.setItem(name, data);
            }
        }
        catch (er) {
            if (er.name === 'QuotaExceededError') {
                self.clear();
            }
        }
    },
    getItem: function (name) {
        var r;
        var self = this;
        try {
            var ls = window.localStorage;
            if (ls) {
                r = ls.getItem(name);
            }
            else {
                r = self.cache[name];
            }
        }
        catch (er) {
            r = self.cache[name];
        }
        return r;
    },
    clear: function () {
        try {
            var ls = window.localStorage;
            if (ls) {
                ls.clear();
            }
        }
        catch (er) {
        }
    }
};
function convertHttps(str) {
    if (typeof str === 'string') {
        var r = str.replace(/http:/g, '');
        var reg = /^\/\/s[45]\.yy\.com/;
        if (reg.test(r)) {
            r = r.replace(reg, '//s1.yy.com');
        }
        return r;
    }
    else {
        return str;
    }
}
exports.convertHttps = convertHttps;
function type(obj) {
    var r = null;
    var toString = Object.prototype.toString;
    if (obj === null) {
        r = String(obj);
    }
    else {
        r = toString.call(obj).toLowerCase();
        r = r.substring(8, r.length - 1);
    }
    return r;
}
exports.type = type;
function isPlainObject(obj) {
    var key;
    var hasOwn = Object.prototype.hasOwnProperty;
    if (!obj || type(obj) !== 'object') {
        return false;
    }
    if (obj.constructor &&
        !hasOwn.call(obj, 'constructor') &&
        !hasOwn.call(obj.constructor.prototype, 'isPrototypeOf')) {
        return false;
    }
    for (key in obj) {
    }
    return key === undefined || hasOwn.call(obj, key);
}
exports.isPlainObject = isPlainObject;
function extend() {
    var argu = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        argu[_i] = arguments[_i];
    }
    var options;
    var name;
    var src;
    var copy;
    var copyIsArray;
    var clone;
    var target = arguments[0] || {};
    var i = 1;
    var length = arguments.length;
    var deep = false;
    if (typeof target === 'boolean') {
        deep = target;
        target = arguments[1] || {};
        i = 2;
    }
    if (typeof target !== 'object' && type(target) !== 'function') {
        target = {};
    }
    if (length === i) {
        target = this;
        --i;
    }
    for (; i < length; i++) {
        options = arguments[i];
        if (options !== null) {
            for (name in options) {
                if (options.hasOwnProperty(name)) {
                    src = target[name];
                    copy = options[name];
                    if (target === copy) {
                        continue;
                    }
                    copyIsArray = type(copy);
                    if (deep &&
                        copy &&
                        (isPlainObject(copy) ||
                            (copyIsArray === 'array'))) {
                        if (copyIsArray) {
                            copyIsArray = false;
                            clone =
                                src && type(src) === 'array' ? src : [];
                        }
                        else {
                            clone =
                                src && isPlainObject(src) ? src : {};
                        }
                        target[name] = extend(deep, clone, copy);
                    }
                    else if (copy !== undefined) {
                        target[name] = copy;
                    }
                }
            }
        }
    }
    return target;
}
exports.extend = extend;
function debounce(func, wait, immediate) {
    var timeout = 0;
    return function () {
        var context = this;
        var args = arguments;
        var later = function () {
            timeout = null;
            if (!immediate) {
                func.apply(context, args);
            }
        };
        var callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) {
            func.apply(context, args);
        }
    };
}
exports.debounce = debounce;
function throttle(func, wait, options) {
    var context = null;
    var args = null;
    var result = null;
    var timeout = null;
    var previous = 0;
    if (!options) {
        options = {};
    }
    var later = function () {
        previous = options.leading === false ? 0 : Date.now();
        timeout = null;
        result = func.apply(context, args);
        if (!timeout) {
            context = args = null;
        }
    };
    return function () {
        var now = Date.now();
        if (!previous && options.leading === false) {
            previous = now;
        }
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0 || remaining > wait) {
            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }
            previous = now;
            result = func.apply(context, args);
            if (!timeout) {
                context = args = null;
            }
        }
        else if (!timeout && options.trailing !== false) {
            timeout = setTimeout(later, remaining);
        }
        return result;
    };
}
exports.throttle = throttle;
function getParameterByName(name, url) {
    if (!url) {
        url = window.location.href;
    }
    name = name.replace(/[[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
    var results = regex.exec(url);
    if (!results) {
        return null;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
exports.getParameterByName = getParameterByName;
function escapeToNull(str) {
    return String(str).replace(/[<>"'`?/]/g, '');
}
exports.escapeToNull = escapeToNull;
exports.cookies = {
    get: function (name) {
        var arr = document.cookie.match(new RegExp('(^| )' + name + '=([^;]*)(;|$)'));
        if (arr !== null) {
            return unescape(arr[2]);
        }
        return null;
    },
    erase: function (name, path, domain) {
        if (exports.cookies.get(name)) {
            document.cookie = name + "=" + (path ? ";path=" + path : '') + (domain ? ";domain=" + domain : '') + ";expires=Thu, 01 Jan 1970 00:00:01 GMT";
        }
    },
    keys: function () {
        if (!document.cookie) {
            return [];
        }
        return document.cookie.split(';').map(function (pair) {
            return pair.split('=')[0].trim();
        });
    }
};
function forEach(arr, fn) {
    return __awaiter(this, void 0, void 0, function () {
        var i;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    i = 0;
                    _a.label = 1;
                case 1:
                    if (!(i < arr.length)) return [3, 4];
                    return [4, fn(arr[i], i)];
                case 2:
                    if ((_a.sent()) === true) {
                        return [3, 4];
                    }
                    _a.label = 3;
                case 3:
                    i++;
                    return [3, 1];
                case 4: return [2];
            }
        });
    });
}
exports.forEach = forEach;
function makeAwait(fn) {
    return new Promise(fn);
}
exports.makeAwait = makeAwait;
function moneyFormat(num) {
    return num.toLocaleString().replace(/\.00$/, '') || '0';
}
exports.moneyFormat = moneyFormat;
function getScript(src) {
    return __awaiter(this, void 0, void 0, function () {
        var script, headEl;
        return __generator(this, function (_a) {
            script = document.createElement('script');
            headEl = document.getElementsByTagName('head')[0];
            return [2, new Promise(function (next) {
                    if (script.readyState) {
                        script.onreadystatechange = function () {
                            if (script.readyState === 'loaded' || script.readyState === 'complete') {
                                script.onreadystatechange = null;
                                next();
                            }
                        };
                    }
                    else {
                        script.onload = function () {
                            script.onload = null;
                            next();
                        };
                    }
                    script.src = src;
                    headEl.appendChild(script);
                })];
        });
    });
}
exports.getScript = getScript;

}.call(window));